import React from "react";

export const Pie13 = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={28} height={28} rx={1} fill="#F1F2F6" />

    <path
      fill="#07C082"
      d="M14,4v5c2.8,0,5,2.2,5,5s-2.2,5-5,5s-5-2.2-5-5c0-0.6,0.1-1.3,0.4-1.9l-4.6-1.9c-2.1,5.1,0.4,10.9,5.5,13
		c5.1,2.1,10.9-0.4,13-5.5c2.1-5.1-0.4-10.9-5.5-13c0,0,0,0,0,0C16.6,4.2,15.3,4,14,4z"
    />
    <path
      fill="#E54D64"
      d="M14,9V4c-4.1,0-7.7,2.5-9.3,6.2l4.6,1.9C10.1,10.2,12,9,14,9z"
    />
  </g>
);
